import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { Observable } from 'rxjs';

import { UserSelectContainerComponent } from '@recruitee/account-ui';
import { I18nService, TranslatePipe } from '@recruitee/i18n';
import {
  BadgeComponent,
  BoxComponent,
  FixedSelectOptionsHelper,
  FormFieldComponent,
  HeadingComponent,
  IconHelpComponent,
  InputComponent,
  LabelComponent,
  NumericInputComponent,
  RtTooltip,
  SelectComponent,
  SelectOption,
} from '@recruitee/user-interface';

import { RequisitionForm, AvailableFieldsMap, FormBox } from '../../../requisitions.types';
import { RequisitionFormManagerService } from '../../../services/requisition-form-manager.service';
import { DynamicSelectFieldComponent } from '../../form-elements/dynamic-select-field/dynamic-select-field.component';
import { SalaryFormGroupComponent } from '../../form-elements/salary-form-group/salary-form-group.component';

type FixedSelectOptions = {
  categories: SelectOption[];
  educations: SelectOption[];
  employmentTypes: SelectOption[];
  experiences: SelectOption[];
  salaryPeriods: SelectOption[];
};

@Component({
  selector: 'rt-requisitions-details-form',
  templateUrl: './requisitions-details-form.component.html',
  styleUrls: ['./requisitions-details-form.component.less'],
  imports: [
    BadgeComponent,
    BoxComponent,
    DynamicSelectFieldComponent,
    FormFieldComponent,
    HeadingComponent,
    IconHelpComponent,
    InputComponent,
    LabelComponent,
    RtTooltip,
    SalaryFormGroupComponent,
    SelectComponent,
    TranslatePipe,
    ReactiveFormsModule,
    NumericInputComponent,
    UserSelectContainerComponent,
  ],
})
export class RequisitionsDetailsFormComponent {
  @Input() public form: FormGroup<RequisitionForm>;
  @Input() public availableDetailsFields: AvailableFieldsMap[FormBox.Details];
  @Input() public departmentSelectOptions: SelectOption[];
  @Input() public isFormEditable: boolean;
  @Input() public isDepartmentsMode: boolean;

  public selectOptions: FixedSelectOptions = {
    employmentTypes: this.fixedSelectOptions.getEmploymentTypeSelectOptions(),
    educations: this.fixedSelectOptions.getEducationSelectOptions(),
    experiences: this.fixedSelectOptions.getExperienceSelectOptions(),
    categories: this.fixedSelectOptions.getCategorySelectOptions(),
    salaryPeriods: this.fixedSelectOptions.getSalaryPeriodSelectOptions(),
  };

  public formFieldsConfig = {
    department: {
      label: this.i18n.translate('app.offer_form.department'),
      searchPlaceholder: this.i18n.translate('app.common.placeholders.search.departments.other'),
      formControlName: 'departmentId',
    },
  };

  constructor(
    private fixedSelectOptions: FixedSelectOptionsHelper,
    private i18n: I18nService,
    public requisitionFormManager: RequisitionFormManagerService,
  ) {}

  public get requisitionUpdated$(): Observable<void> {
    return this.requisitionFormManager.updated$;
  }

  public setUserSelectFieldValue(fieldName: string, value: number | null) {
    this.form.get(fieldName)?.setValue(value);
    this.form.markAsDirty();
  }

  public hasFormGroupAllFieldsFilled(formGroup?: FormGroup): boolean {
    if (!formGroup) return false;
    return Object.values(formGroup.controls).every(control => control.value);
  }
}
